<template>
  <div
    class="wl-radio group flex items-center gap-x-3 py-2.5 text-sm font-medium leading-5 transition duration-150 hover:bg-muted"
    :class="{
      'is-selected': value === modelValue,
      'is-disabled pointer-events-none cursor-default opacity-30': isDisabled,
      'is-boxed rounded-2xl bg-muted px-3': isBoxed,
    }"
    @click="onClick"
  >
    <input
      :id="id"
      class="relative m-0 size-4 shrink-0 appearance-none rounded-full border border-emphasis bg-default outline-offset-1 transition duration-150 checked:border checked:border-solid checked:border-transparent checked:bg-accent checked:after:absolute checked:after:inset-0 checked:after:m-auto checked:after:h-1.5 checked:after:w-1.5 checked:after:rounded-full checked:after:bg-default hover:border hover:border-accent-emphasis focus-visible:outline focus-visible:outline-1 focus-visible:outline-accent group-hover:border-neutral"
      type="radio"
      :name="name"
      :value="value"
      :checked="value === modelValue"
      :disabled="isDisabled"
      @click.stop
      @change="onClick"
    />
    <label class="grow truncate text-emphasis" :for="id" @click.stop>
      <template v-if="$slots.label">
        <slot name="label" />
      </template>
      <template v-else>
        {{ label }}
      </template>
    </label>
    <slot name="suffix" />
  </div>
</template>

<script lang="ts" setup>
import { toRefs } from "vue";
import { useWebHaptics } from "../../composables/use-web-haptics";
import { type WLRadioEmits, type WLRadioProps } from "./types";

const emit = defineEmits<WLRadioEmits>();
const props = withDefaults(defineProps<WLRadioProps>(), {
  isDisabled: false,
  isBoxed: true,
});

const { id, label, value, modelValue, isDisabled, isBoxed } = toRefs(props);
const { triggerHaptic } = useWebHaptics();

const onClick = (): void => {
  if (isDisabled.value || value.value === modelValue.value) return;

  triggerHaptic("soft");
  emit("update:modelValue", value.value);
};
</script>
